export const NO_AUTH_HEADER = "No authorization header was found";
